"use strict";

import angular from "angular";
import ContactController from "./contact.controller";

export default angular
  .module("dalApp.contact", [])
  .controller("ContactController", ContactController).name;



// WEBPACK FOOTER //
// ./client/app/account/contact/index.js